import { render, staticRenderFns } from "./ChartProfit.vue?vue&type=template&id=c9ca39e4&"
import script from "./ChartProfit.vue?vue&type=script&lang=js&"
export * from "./ChartProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports